import { render, staticRenderFns } from "./customer-table.vue?vue&type=template&id=300e46a9&"
import script from "./customer-table.vue?vue&type=script&lang=js&"
export * from "./customer-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports